export default "__VITE_ASSET__8383c4c6__"